import AgencyService from 'services/agenciesService'
import { ApiRequestBody } from 'interfaces/ApiRequestBody'

interface UpdateAgencyRexIdRequest extends ApiRequestBody {
  AgencyId: string
  RexId: number
}

const updateAgencyRexId = async (
  requestBody: UpdateAgencyRexIdRequest
): Promise<string | undefined> => {
  const { getAuthToken } = requestBody

  const token = await getAuthToken()
  const service = new AgencyService(token)

  const { data } =
    (await service.agencyService.post('UpdateAgencyRexId', requestBody)) ?? {}

  return data
}

export default updateAgencyRexId
